import React, { useState } from 'react';
import { Send, User, Phone, Mail, MessageSquare } from 'lucide-react';
import { createContact } from '../lib/api';
import { useToast } from '../hooks/use-toast';

const GetInTouch = ({ compact = false }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', phone: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.message) {
      toast({ title: 'Please fill required fields', description: 'Name and message are required.', variant: 'destructive' });
      return;
    }
    setLoading(true);
    try {
      await createContact(form);
      toast({ title: 'Message sent!', description: 'Our team will get back to you shortly.' });
      setForm({ name: '', phone: '', email: '', message: '' });
    } catch {
      toast({ title: 'Something went wrong', variant: 'destructive' });
    }
    setLoading(false);
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className={compact ? 'space-y-4' : 'grid md:grid-cols-3 gap-4'}>
        <div className="relative">
          <User size={17} className="absolute left-3 top-3.5 text-gray-400" />
          <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your Name *"
            className="w-full pl-10 pr-3 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#0f7a37] text-sm" />
        </div>
        <div className="relative">
          <Phone size={17} className="absolute left-3 top-3.5 text-gray-400" />
          <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Phone Number"
            className="w-full pl-10 pr-3 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#0f7a37] text-sm" />
        </div>
        <div className="relative">
          <Mail size={17} className="absolute left-3 top-3.5 text-gray-400" />
          <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email Address"
            className="w-full pl-10 pr-3 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#0f7a37] text-sm" />
        </div>
      </div>
      <div className="relative">
        <MessageSquare size={17} className="absolute left-3 top-3.5 text-gray-400" />
        <textarea value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} placeholder="Your Message *" rows={compact ? 4 : 5}
          className="w-full pl-10 pr-3 py-3 rounded-xl border border-gray-200 outline-none focus:border-[#0f7a37] text-sm resize-none" />
      </div>
      <button type="submit" disabled={loading}
        className="nl-btn bg-[#0f7a37] hover:bg-[#0d5228] text-white px-7 py-3 disabled:opacity-60">
        <Send size={17} /> {loading ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
};

export default GetInTouch;
